import { type FC } from 'react';
import styles from './NftPdpOwners.scss';
import { FormattedMessage } from 'dibs-react-intl';
import { graphql, useFragment } from 'react-relay';
import { Badge } from 'dibs-elements/exports/Badge.tsx';
import { NftPdpUserLink } from '../components/NftPdpUserLink.tsx';
import { type NftPdpOwners_viewer$key } from './__generated__/NftPdpOwners_viewer.graphql.ts';
import { type NftPdpOwners_nftItem$key } from './__generated__/NftPdpOwners_nftItem.graphql.ts';

type Props = {
    viewer: NftPdpOwners_viewer$key;
    nftItem: NftPdpOwners_nftItem$key;
};

export const NftPdpOwners: FC<Props> = ({ viewer: viewerRef, nftItem: nftItemRef }) => {
    const viewer = useFragment(
        graphql`
            fragment NftPdpOwners_viewer on Viewer {
                nftBalancesByItem(nftId: $nftId) {
                    chainId
                    ownerAddress {
                        address
                        ...NftPdpUserLink_ethereumAddress
                    }
                    balance
                }
                user(userId: $userId) @include(if: $fetchUser) {
                    ethereumWalletAddress {
                        address
                    }
                }
            }
        `,
        viewerRef
    );
    const nftItem = useFragment(
        graphql`
            fragment NftPdpOwners_nftItem on NftItem {
                creatorAddress {
                    address
                }
            }
        `,
        nftItemRef
    );

    const { nftBalancesByItem } = viewer;
    const creatorAddress = nftItem?.creatorAddress?.address;
    const userWalletAddress = viewer?.user?.ethereumWalletAddress?.address;

    return (
        <div>
            {nftBalancesByItem
                ?.filter(owner => owner?.balance && owner?.balance > 0)
                ?.map((owner, index) => {
                    return (
                        <div className={styles.ownerContainer} key={index}>
                            <div className={styles.ownerLink}>
                                <NftPdpUserLink
                                    nftEthereumAddress={owner?.ownerAddress ?? null}
                                    userWalletAddress={userWalletAddress}
                                />
                                {owner?.ownerAddress?.address === creatorAddress && (
                                    <Badge type="neutral">Creator</Badge>
                                )}
                            </div>
                            <div className={styles.ownerBalance}>
                                <FormattedMessage
                                    id="nft.pdp.tabs.owners.balance"
                                    defaultMessage="{balance, plural, one {# edition} other {# editions}}"
                                    values={{ balance: owner?.balance }}
                                />
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};
